module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAANCAYAAACtpZ5jAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoMESQltqI5OAAAAJJJREFUOMut09EJAyEMBuA/R8AxnMQ3J+kYheLDQce4ZTKJYwhC+iRYelfUXF4D3x8TpFwLAMCz05QSHq8n4YbaGioiiDHCs1PPTo/9rRaYAKiInDZDCACAlZfwv2Yf6NnpTAiPTjAbwiv7Gwlh6/WvQsxwf+Bci23iK2xpxyPYMDyLfcG5Fmo/z4r9TNxwK9bXB7FBVq3z8+raAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_r.png
// module id = LagP
// module chunks = 1